import { deleteTenantRole } from '@infuse/api/iam/tenant';
import { useGenericDeleteRole } from '@infuse/iam/role/mutations';

export const useDeleteTenantRole = () => {
  return useGenericDeleteRole({
    apiFn: deleteTenantRole
  });
};
